import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames2';
import React, { Component } from 'react';
import { createButton } from '../../Button/Button';
import { Icon } from '../../Icon';
import { Tooltip } from '../../Tooltip';
import styles from './InteractiveColumnHeader.scss';
export var InteractiveColumnHeader = /*#__PURE__*/function (_Component) {
  _inherits(InteractiveColumnHeader, _Component);

  var _super = _createSuper(InteractiveColumnHeader);

  function InteractiveColumnHeader(props) {
    var _this;

    _classCallCheck(this, InteractiveColumnHeader);

    _this = _super.call(this, props);

    _this.onClick = function () {
      if (_this.props.openFilterDropdown) {
        _this.props.openFilterDropdown(_this.props.column.getColDef().field, _this.columnHeaderRef.current);
      } else {
        _this.props.showColumnMenu(_this.columnHeaderRef.current);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          shouldMoveToCell = _this$props.shouldMoveToCell,
          moveToCell = _this$props.moveToCell;

      if (shouldMoveToCell && moveToCell) {
        moveToCell(event);
      }
    };

    _this.onSortChanged = function () {
      _this.forceUpdate();
    };

    _this.onFilterActiveChanged = function () {
      _this.forceUpdate();
    }; // this is required to make the parent container expand itself to fit the entire column


    props.reactContainer.style.display = 'flex';
    props.reactContainer.style.flex = 1;
    _this.columnHeaderRef = React.createRef();
    props.column.addEventListener('sortChanged', _this.onSortChanged);
    props.column.addEventListener('filterActiveChanged', _this.onFilterActiveChanged);
    return _this;
  }

  _createClass(InteractiveColumnHeader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.column.removeEventListener('sortChanged', this.onSortChanged);
      this.props.column.removeEventListener('filterActiveChanged', this.onFilterActiveChanged);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props2 = this.props,
          alignRight = _this$props2.alignRight,
          buttonType = _this$props2.buttonType,
          displayName = _this$props2.displayName,
          dataTest = _this$props2.dataTest,
          loading = _this$props2.loading,
          selected = _this$props2.selected,
          column = _this$props2.column,
          showTooltip = _this$props2.showTooltip,
          tooltipBody = _this$props2.tooltipBody;
      var isSorted = this.props.isSorted || column.isSorting();
      var isFiltered = this.props.isFiltered || column.isFilterActive();
      var Button = createButton(styles.button);
      return React.createElement("div", {
        ref: this.columnHeaderRef,
        onKeyDown: this.handleKeyDown,
        className: cx(styles.headerCell, alignRight ? styles.value : styles.text),
        role: "columnheader"
      }, React.createElement(Button, {
        buttonType: buttonType,
        dataTest: dataTest,
        loading: loading,
        onClick: this.onClick,
        selected: selected
      }, React.createElement("div", {
        className: styles.buttonContentContainer
      }, showTooltip && React.createElement(Tooltip, {
        content: tooltipBody
      }, React.createElement("div", {
        className: cx(styles.iconInfo)
      }, React.createElement(Icon, {
        icon: 'utility-info'
      }))), React.createElement("div", null, displayName), React.createElement("div", {
        "data-test": "column-header-indicator",
        className: cx((_cx = {}, _defineProperty(_cx, styles.inactiveButtonDownArrowContainer, !isSorted && !isFiltered), _defineProperty(_cx, styles.activeButtonDownArrowContainer, isSorted), _defineProperty(_cx, styles.filteredButtonDownArrowContainer, !isSorted && isFiltered), _cx))
      }, React.createElement(Icon, {
        icon: "arrow-caret-down"
      })))));
    }
  }]);

  return InteractiveColumnHeader;
}(Component);